import { render, staticRenderFns } from "./tabDenda.vue?vue&type=template&id=ee7ac71e"
import script from "./tabDenda.vue?vue&type=script&lang=js"
export * from "./tabDenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports